import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { siteInfo } from '@/mocks/common';
import { faqData } from '@/mocks/content';

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 91在线视频',
            description: '了解91在线视频的品牌故事、发展历程和联系方式。我们致力于为用户提供优质的在线视频观看体验。',
            url: 'https://www.91zaixianshipin.com/about',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.91zaixianshipin.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 py-12 md:py-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
              <Link to="/" className="hover:text-accent-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              关于我们
            </h1>
            <p className="text-foreground-500 max-w-[600px]">
              了解91在线视频的品牌故事、发展历程和核心优势。
            </p>
          </div>
        </div>

        <section className="max-w-[1200px] mx-auto px-4 md:px-8 py-12 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
            <div>
              <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-sm font-medium rounded-full mb-4">
                品牌介绍
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
                让精彩内容触手可及
              </h2>
              <div className="space-y-4 text-foreground-600 leading-relaxed">
                <p>
                  91在线视频成立于2018年，是国内领先的在线视频内容平台之一。我们致力于通过技术创新和内容整合，为用户提供流畅、丰富、高品质的在线视频观看体验。
                </p>
                <p>
                  经过多年的发展，91在线视频已建立起覆盖电影、电视剧、综艺、动漫、纪录片、短视频等全品类的视频内容库。我们与国内外多家内容制作方和发行方建立了深度合作关系，确保平台内容持续更新、品类不断丰富。
                </p>
                <p>
                  我们的团队由一群热爱视频内容的年轻人组成，涵盖技术开发、内容运营、产品设计和客户服务等多个领域。大家怀揣着共同的愿景——让每一位用户都能方便快捷地获取自己喜爱的视频内容。
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20diverse%20team%20collaborating%2C%20warm%20lighting%2C%20minimalist%20design%2C%20large%20screens%20displaying%20video%20content%2C%20creative%20atmosphere%2C%20professional%20yet%20casual%20environment&width=1000&height=700&seq=about-brand&orientation=landscape"
                alt="91在线视频团队"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-18">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
              平台数据
            </h2>
            <p className="text-foreground-500 text-center mb-10 max-w-[500px] mx-auto">
              经过多年发展，91在线视频已成为深受用户信赖的在线视频平台
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
              <div className="text-center p-5 md:p-6 bg-background-50 rounded-2xl">
                <div className="font-heading text-3xl md:text-4xl font-black text-primary-500 mb-2">5000万+</div>
                <p className="text-foreground-500 text-sm">累计注册用户</p>
              </div>
              <div className="text-center p-5 md:p-6 bg-background-50 rounded-2xl">
                <div className="font-heading text-3xl md:text-4xl font-black text-accent-500 mb-2">10万+</div>
                <p className="text-foreground-500 text-sm">视频资源总量</p>
              </div>
              <div className="text-center p-5 md:p-6 bg-background-50 rounded-2xl">
                <div className="font-heading text-3xl md:text-4xl font-black text-primary-500 mb-2">99.9%</div>
                <p className="text-foreground-500 text-sm">服务可用率</p>
              </div>
              <div className="text-center p-5 md:p-6 bg-background-50 rounded-2xl">
                <div className="font-heading text-3xl md:text-4xl font-black text-accent-500 mb-2">200+</div>
                <p className="text-foreground-500 text-sm">合作内容方</p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-18">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
              用户口碑
            </h2>
            <p className="text-foreground-500 text-center mb-10 max-w-[500px] mx-auto">
              来自真实用户的使用评价，您的满意是我们前进的动力
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="bg-background-50 rounded-2xl p-6 md:p-7">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-foreground-600 leading-relaxed mb-5 text-sm">
                  &ldquo;91在线视频真的非常方便，资源更新快，画质清晰流畅。无论是追剧还是看电影，体验都很好。特别推荐给喜欢在线看视频的朋友们。&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20young%20man%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20simple%20lighting%2C%20corporate%20style&width=96&height=96&seq=avatar-about-01&orientation=squarish"
                    alt="张先生"
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">张先生</p>
                    <p className="text-xs text-foreground-500">资深用户 · 使用3年</p>
                  </div>
                </div>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-7">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-foreground-600 leading-relaxed mb-5 text-sm">
                  &ldquo;作为重度追剧用户，91的视频库真的是太全了！APP做得也很好用，离线缓存功能出差时特别实用。&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20young%20woman%2C%20clean%20white%20background%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20modern%20style&width=96&height=96&seq=avatar-about-02&orientation=squarish"
                    alt="李女士"
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">李女士</p>
                    <p className="text-xs text-foreground-500">VIP会员 · 使用2年</p>
                  </div>
                </div>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-7">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-foreground-600 leading-relaxed mb-5 text-sm">
                  &ldquo;从网站到APP，91一直在进步。更新及时，入口稳定，客服响应也很快。会一直支持下去。&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20middle%20aged%20man%2C%20clean%20white%20background%2C%20confident%20look%2C%20business%20style%2C%20soft%20lighting&width=96&height=96&seq=avatar-about-03&orientation=squarish"
                    alt="王先生"
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">王先生</p>
                    <p className="text-xs text-foreground-500">高级用户 · 使用4年</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-[1200px] mx-auto px-4 md:px-8 py-14 md:py-18">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
            商务合作
          </h2>
          <p className="text-foreground-500 text-center mb-10 max-w-[500px] mx-auto">
            欢迎内容方、广告主、品牌方与我们建立合作关系，共创共赢
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-[1000px] mx-auto">
            <div className="space-y-5">
              <div className="flex gap-4 p-5 bg-background-50 rounded-2xl border border-background-200/70">
                <div className="w-12 h-12 bg-accent-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-film-line text-xl text-accent-600"></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">内容合作</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">影视版权引进、内容分发合作、联合出品等。联系邮箱：content@91zaixianshipin.com</p>
                </div>
              </div>
              <div className="flex gap-4 p-5 bg-background-50 rounded-2xl border border-background-200/70">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-megaphone-line text-xl text-primary-600"></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">广告合作</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">品牌广告投放、原生广告植入、定制化营销方案。联系邮箱：ad@91zaixianshipin.com</p>
                </div>
              </div>
              <div className="flex gap-4 p-5 bg-background-50 rounded-2xl border border-background-200/70">
                <div className="w-12 h-12 bg-secondary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-xl text-secondary-600"></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">战略合作</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">技术合作、渠道拓展、品牌联名等深度合作。联系邮箱：partner@91zaixianshipin.com</p>
                </div>
              </div>
            </div>
            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">合作咨询</h3>
              <form
                data-readdy-form
                id="business-cooperation-form"
                action="https://readdy.ai/api/form/d96af6ttfb6ioa7s1m20"
                method="POST"
                encType="application/x-www-form-urlencoded"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                  if (honeypot) {
                    const successMsg = document.getElementById('coop-form-success');
                    if (successMsg) successMsg.style.display = 'block';
                    form.reset();
                    return;
                  }
                  const params = new URLSearchParams();
                  formData.forEach((value, key) => {
                    if (key !== 'phone_alt' && typeof value === 'string') {
                      params.append(key, value);
                    }
                  });
                  try {
                    const res = await fetch(form.action, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: params.toString(),
                    });
                    const responseText = await res.text();
                    let parsed: any = {};
                    try { parsed = JSON.parse(responseText); } catch (_e) { /* ignore parse error */ }
                    const errorEl = document.getElementById('coop-form-error');
                    const successEl = document.getElementById('coop-form-success');
                    if (res.ok && parsed?.code === 'OK') {
                      if (successEl) successEl.style.display = 'block';
                      if (errorEl) errorEl.style.display = 'none';
                      form.reset();
                    } else {
                      const msg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || '提交失败，请稍后重试';
                      if (errorEl) { errorEl.textContent = msg; errorEl.style.display = 'block'; }
                      if (successEl) successEl.style.display = 'none';
                    }
                  } catch (_e) {
                    const errorEl = document.getElementById('coop-form-error');
                    if (errorEl) { errorEl.textContent = '网络错误，请检查网络后重试'; errorEl.style.display = 'block'; }
                  }
                }}
              >
                <div className="space-y-4">
                  <div>
                    <label htmlFor="coop-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input type="text" id="coop-name" name="name" required className="w-full px-4 py-2.5 rounded-xl border border-background-200/70 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all" placeholder="请输入您的姓名" />
                  </div>
                  <div>
                    <label htmlFor="coop-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input type="email" id="coop-email" name="email" required className="w-full px-4 py-2.5 rounded-xl border border-background-200/70 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all" placeholder="请输入您的邮箱" />
                  </div>
                  <div>
                    <label htmlFor="coop-company" className="block text-sm font-medium text-foreground-700 mb-1.5">公司名称</label>
                    <input type="text" id="coop-company" name="company" required className="w-full px-4 py-2.5 rounded-xl border border-background-200/70 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all" placeholder="请输入您的公司名称" />
                  </div>
                  <div>
                    <label htmlFor="coop-type" className="block text-sm font-medium text-foreground-700 mb-1.5">合作类型</label>
                    <select id="coop-type" name="cooperation_type" required className="w-full px-4 py-2.5 rounded-xl border border-background-200/70 bg-background-100 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all cursor-pointer appearance-none">
                      <option value="">请选择合作类型</option>
                      <option value="内容合作">内容合作</option>
                      <option value="广告合作">广告合作</option>
                      <option value="战略合作">战略合作</option>
                      <option value="其他合作">其他合作</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="coop-message" className="block text-sm font-medium text-foreground-700 mb-1.5">合作意向说明</label>
                    <textarea id="coop-message" name="message" rows={3} maxLength={500} className="w-full px-4 py-2.5 rounded-xl border border-background-200/70 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none" placeholder="请简要描述合作意向（限500字）"></textarea>
                  </div>
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="form-anti-spam" />
                  <button type="submit" className="whitespace-nowrap w-full px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer">
                    提交合作意向
                  </button>
                </div>
                <p id="coop-form-success" className="mt-4 text-sm text-green-600 font-medium text-center" style={{ display: 'none' }}>感谢您的合作意向，我们会尽快与您联系！</p>
                <p id="coop-form-error" className="mt-4 text-sm text-red-500 font-medium text-center" style={{ display: 'none' }}></p>
              </form>
            </div>
          </div>
        </section>

        <section className="max-w-[1200px] mx-auto px-4 md:px-8 py-14 md:py-18">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
            联系我们
          </h2>
          <p className="text-foreground-500 text-center mb-10 max-w-[500px] mx-auto">
            如有任何疑问或合作意向，欢迎通过以下方式与我们取得联系
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 max-w-[900px] mx-auto">
            <div className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/70">
              <div className="w-14 h-14 bg-accent-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">电子邮箱</h3>
              <p className="text-sm text-foreground-500">{siteInfo.email}</p>
            </div>
            <div className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/70">
              <div className="w-14 h-14 bg-primary-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">客服热线</h3>
              <p className="text-sm text-foreground-500">{siteInfo.phone}</p>
            </div>
            <div className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/70">
              <div className="w-14 h-14 bg-secondary-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">办公地址</h3>
              <p className="text-sm text-foreground-500">{siteInfo.address}</p>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-18">
          <div className="max-w-[900px] mx-auto px-4 md:px-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
              常见问题
            </h2>
            <p className="text-foreground-500 text-center mb-10">
              快速了解91在线视频的常见问题与解答
            </p>
            <div className="space-y-3">
              {faqData.map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-2xl border border-background-200/70">
                  <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                    <span className="font-heading text-base font-bold text-foreground-900 pr-4">{faq.question}</span>
                    <span className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0 group-open:bg-accent-100 group-open:text-accent-600 transition-colors">
                      <i className="ri-add-line group-open:hidden"></i>
                      <i className="ri-subtract-line hidden group-open:block"></i>
                    </span>
                  </summary>
                  <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-foreground-600 leading-relaxed border-t border-background-200/70 pt-4 -mt-1">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}